import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const PoolRecreation = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="pool-recreation"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path d="M14.94 41.707l.07-7.157-.07-2.05.626.563c.474.28 1.022.352 1.524.235l8.231-1.917a2.07 2.07 0 001.545-2.485 2.064 2.064 0 00-2.483-1.545l-7.423 1.73L15 28l1.5-.381 4.963-1.157 4.409-3.987a2.07 2.07 0 00-2.777-3.068L16.79 25.11l-4.33-1.413c-.066-.023-1.107-.216-1.48-.216H9.27a4.108 4.108 0 00-4.107 4.108v17.23c2.109-1.583 3.163-4.746 9.776-3.112zM10.147 22.282a4.77 4.77 0 100-9.541 4.771 4.771 0 100 9.54zM37.593 20.669a2.07 2.07 0 00-.315 2.908l5.692 7.084c.148.183.324.339.521.463l3.763 2.334s.78 1.03.746 1.363l-2.868 1.493-7.423-1.73a2.068 2.068 0 10-.938 4.029l8.231 1.918a2.07 2.07 0 001.524-.235L48.4 39.5v3.21c1.582-1.583 6.632-1.703 8.529 0V34.82a4.107 4.107 0 00-4.106-4.107h-1.707c-.128 0-.25.025-.374.037l-4.768-2.957-5.471-6.807a2.073 2.073 0 00-2.91-.318z" />
        <path d="M51.946 29.514a4.77 4.77 0 100-9.54 4.77 4.77 0 000 9.54zM35.201 16.07a4.871 4.871 0 100-9.743 4.872 4.872 0 100 9.743zM55.959 46.759c-2.61-2.345-6.843-2.345-9.454 0l-.02.018-.02.019c-2.611 2.345-6.844 2.345-9.454 0l-.02-.019-.021-.018c-2.61-2.345-6.843-2.345-9.454 0l-.02.018-.02.019c-2.61 2.345-6.843 2.345-9.454 0l-.02-.019-.02-.018c-2.611-2.345-6.844-2.345-9.455 0l-.02.018-.02.019A6.799 6.799 0 016 48.206V56h50v-9.204l-.041-.037z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" transform="translate(3 3)" d="M0 0h55v55H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
/* eslint-enable max-len */

PoolRecreation.defaultProps = {
  className: null,
};

PoolRecreation.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default PoolRecreation;
